export default function includes(str = '', searchStr = '') {
  return str.toLowerCase().includes(searchStr.toLowerCase());
}
